import { FC } from 'react'

import { AIPlanCustomSection } from 'api/interfaces/AIPlan'
import { MasterCampaignPlanCampaignBuilder } from 'api/interfaces/MasterCampaignStub'

import { getBudgetContent } from 'features/planner/pages/MasterCampaignPlanPage/utils/planContentUtils'
import CustomizableSection from 'features/planner/pages/MasterCampaignPlanPage/components/ExecutiveSummary/CustomizableSection'

export interface AIPlanBudgetProps {
  campaigns: MasterCampaignPlanCampaignBuilder[]
  section?: AIPlanCustomSection | null
  onDelete: () => void
  showActions?: boolean
}

const AIPlanBudget: FC<AIPlanBudgetProps> = ({ campaigns, section, onDelete, showActions = true }) => {
  const budgetText = getBudgetContent(campaigns, true)

  return <CustomizableSection section={section as any} defaultTitle='Budget' defaultContent={budgetText} defaultShowTitle={true} separator='spacer' onDelete={onDelete} showActions={showActions} />
}

export default AIPlanBudget
